import type { INotificationTypes, ISubscribeNotification } from '@/modules/admin/type'
import Net from '@/services/net'

export function markNotificationReadOrUnread(id: number, read = true) {
  let url = `/usernotifications/read`
  if (read) {
    url = `/usernotifications/unread`
  }
  return Net.t1.put(url, [{ Id: id }])
}

export function subscribeNotifications(data: ISubscribeNotification[]) {
  return Net.t1.post<ISubscribeNotification[]>(`/notifications/subscribe`, data)
}

export function getNotificationTypes() {
  return Net.t1.get<INotificationTypes[]>(`/notificationtypes`)
}
